import { render, staticRenderFns } from "./FormSwitcher.vue?vue&type=template&id=164e0f5c&scoped=true"
import script from "./FormSwitcher.vue?vue&type=script&lang=js"
export * from "./FormSwitcher.vue?vue&type=script&lang=js"
import style0 from "./FormSwitcher.vue?vue&type=style&index=0&id=164e0f5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e0f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164e0f5c')) {
      api.createRecord('164e0f5c', component.options)
    } else {
      api.reload('164e0f5c', component.options)
    }
    module.hot.accept("./FormSwitcher.vue?vue&type=template&id=164e0f5c&scoped=true", function () {
      api.rerender('164e0f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_v2/Form/FormSwitcher.vue"
export default component.exports